import { Controller } from "@hotwired/stimulus"

// business-services--learning-projects--program-dates-constraints
export default class extends Controller {
  static targets = [
    "startedOnInput",
    "endedOnInput"
  ]

  static values = {
    endDateLimits: {
      type: Object,
      default: {}
    },
    dateFormat: {
      type: String,
      default: "DD/MM/YYYY"
    }
  }

  initialize() {
    $(this.startedOnInputTarget).on("change", this.initEndDatePicker.bind(this));
  }

  initEndDatePicker() {
    let parsedStartDate = moment($(this.startedOnInputTarget).val(), this.dateFormatValue);
    let parsedEndDate = moment($(this.endedOnInputTarget).val(), this.dateFormatValue);
    let min = moment(parsedStartDate).add(this.endDateLimitsValue.min, 'days');
    let max = moment(parsedStartDate).add(this.endDateLimitsValue.max, 'days');

    this.initializeDatePicker(min.format(this.dateFormatValue), max.format(this.dateFormatValue));

    if(parsedEndDate.isBefore(min)) {
      $(this.endedOnInputTarget).val(min.format(this.dateFormatValue));
    }

    if(parsedEndDate.isAfter(max)) {
      $(this.endedOnInputTarget).val(max.format(this.dateFormatValue));
    }
  }

  initializeDatePicker(minDate, maxDate) {
    var dateInput = $(this.endedOnInputTarget);
    var options = {
      singleDatePicker: true,
      minDate: minDate,
      maxDate: maxDate,
      showDropdowns: true,
      autoApply: true,
      autoUpdateInput: false,
      locale: {
        format: this.dateFormatValue,
        firstDay: 1
      }
    };

    dateInput.daterangepicker(options, function(start, end, label) {
      dateInput.val(start.format(this.locale.format)).change();
      window.preventHidingDropdowns = true;
    });
  }
}
